/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Create_New_PromptInputs */



/**
* | output |
* | --- |
* | "Create a new Share to begin." |
*
* @param {Team_Share_Create_New_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_create_new_prompt = /** @type {((inputs?: Team_Share_Create_New_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Create_New_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un nouveau partage pour commencer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie zunächst eine neue Freigabe.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per iniziare, crea una nuova condivisione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для начала создайте новую общую папку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crea un nuevo recurso compartido para comenzar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("首先，创建一个新的共享文件夹。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには新しい共有を作成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत करने के लिए एक नया शेयर बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie um novo compartilhamento para começar.")
	return /** @type {LocalizedString} */ ("Create a new Share to begin.")
});